import { Component, OnInit, inject, DestroyRef, effect, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as _ from 'lodash';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ScoreWidgetComponent } from '../score-widget/score-widget.component';
import { NgStyle, NgIf } from '@angular/common';
import { ScoreDropdownMenuComponent } from '../score-dropdown-menu/score-dropdown-menu.component';
import { OverviewTableComponent } from './sub-component/overview-table/overview-table.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import {
  attachMetricDeviations,
  attachSummaryDeviations,
  getAccountSummaryMetrics,
  getComparisonPeriodLabel,
  getShowComparisonFlag,
  isComparisonAvailable,
  setShowComparisonFlag,
} from 'src/app/shared/utils/score-deviation.util';
import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';

@Component({
  selector: 'app-score-overview',
  templateUrl: './score-overview.component.html',
  styleUrl: './score-overview.component.scss',
  imports: [ScoreWidgetComponent, NgStyle, NgIf, ScoreDropdownMenuComponent, OverviewTableComponent, LtmsLoaderComponent]
})
export class ScoreOverviewComponent implements OnInit {
  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;
  @Input() showComparisonFlag: boolean = false;
  @Output() showComparisonFlagChange = new EventEmitter<boolean>();
  @ViewChild('drilldownCardContainer') drilldownCardContainer!: ElementRef;
  desclaimer: any = {
    main: 'View performance scores in list and heatmap formats for quick evaluation.',
    topperformer: ' Identifies top performers to highlight areas of excellence.',
    bottomPerformer: '  Identifies bottom performers to highlight areas of improvement.'
  }
  destroyRef = inject(DestroyRef);
  rowDropdown: any = {
    config: {
      'width': '218px',
      'tab': 'comparision'
    },
    selectedOption: 'Select',
    options: []
  }
  columnDropdown: any = {
    config: {
      'width': '218px',
      'tab': 'comparision'
    },
    selectedOption: 'Select',
    options: []
  }

  ddTableConfig: any = {
    showHeatMap: false,
    hideText: false,
    scrollSyncronizeId: 'dd-table-overview',
    style: {
      width: '0px'
    }
  }
  selectedRow: any = {}
  accountDetails: any = null;
  displayProjectAsDefaultColumn: boolean = false;
  query1: any = { "from": "20250101", "to": "20251231", "account_id": "6745630598c7d120e0eb052d", "rater_type": 3, "is_custom_date_range_selected": false, "project_type": 1, "field_id_1": "project", "field_type_1": "project", "field_id_2": "tag_selected_language_key", "field_type_2": "tag" };
  query2: any = { "from": "20250201", "to": "20250205", "account_id": "6745630598c7d120e0eb052d", "rater_type": 3, "is_custom_date_range_selected": true, "project_type": 1, "field_id_1": "project", "field_type_1": "project", "field_id_2": "tag_feedback_reference_token", "field_type_2": "tag" };
  selectedRowFilter: any = {}
  selectedColumnFilter: any = {}
  filterObj: any = {
    currentFilter: {},
    appliedfilters: [],
    next: {}
  }
  nextProject = {
    'name': 'Project',
    'field_id': 'project',
    'type': 'project'
  }
  nextProjectType = {
    'name': 'Project Type',
    'field_id': 'project_type',
    'type': 'project'
  }
  filters: any = []
  drilldownTable: any = { fixedHeader: [], header: [], row: [] };
  overallTable: any = { fixedHeader: [], header: [], row: [] };
  accountId: string = ''
  from: string = ''
  to: string = ''
  selectedTableView: string = 'list'
  isCustomDateRangeSelected: boolean = false;
  dynamicColumns: any = [];
  dynamicColumnKeys: any = [];
  cohortDetail: any = {};
  overallScore: any = null;
  bottomResponses: any = []
  topResponses: any = []

  performersColumns: any = [];
  drillDownCardFullScreen: boolean = false;
  isPerformerDataAvailable: boolean = false;
  isPerformerDataLoading: boolean = true;
  isOverallDataAvailable: boolean = false;
  isOverallDataLoading: boolean = true;
  isDrilldownDataAvailable: boolean = false;
  isDrilldownDataLoading: boolean = true;
  raterType: any = null;
  projectType: any = null;
  filterNameMap: any = {}

  drilldownSequence: any = []
  overallScorekey: any = ''
  universalFilter: any = {}
  isNps: boolean = true;
  isComparisonAvailable: boolean = true;
  dateType: string = '';
  comparisonPeriodLabel: string = '';
  constructor(
    private _analytics: ResponseAnalyticsService,
    private _helpers: HelpersService,
    private _router: Router,
    private _appStateService: AppStateService
  ) {
    effect(() => {
      if (this._appStateService.initialized()) {
        const state: any = this._appStateService.appState();
        this.accountDetails = state.accountDetails;
        this.from = state?.datePicker?.startDate;
        this.to = state?.datePicker?.endDate;
        this.projectType = state?.projectType?.project_type
        this.universalFilter = (state && !_.isEmpty(state.universalFilter)) ? state.universalFilter : {}
        this.isCustomDateRangeSelected = (_.has(state, 'datePicker.isCustomDateRangeSelected')) ? state?.datePicker?.isCustomDateRangeSelected : false;

        if (this.checkRequiredData()) {
          this.refreshComparisonLabels();
          // this.filterObj.appliedfilters = []
          // this.filterObj.next = this.selectedRowFilter
          this.displayProjectAsDefaultColumn = _.get(this.accountDetails, 'leaderboard_config.show_project_as_default_column', false);
          const cohortList = _.get(this.accountDetails, 'leaderboard_config.transactions', []);
          if (cohortList && cohortList.length) {
            this.cohortDetail = cohortList[0];
          }
          const fieldDefinitions = _.get(this.accountDetails, 'field_definitions', []);
          if (fieldDefinitions && fieldDefinitions.length) {
            _.each(fieldDefinitions, (field: any) => {
              this.filterNameMap[field.field_id] = field
            });
          }

          this.performersColumns = this.getPerformersColumn();
          if (state?.accountDetails?._id && this.accountId != state?.accountDetails?._id) {
            this.accountId = state?.accountDetails?._id;
            this.prepareDropDownOption(fieldDefinitions).then(() => {
              this.getOverallSumary();
            });
          } else {
            this.getOverallSumary();
          }
        }
      }
    })
  }
  ngOnInit(): void {
    this.refreshComparisonLabels();
    this._analytics.ratingInfo.subscribe((ratingDetail: any) => {
      if( this.raterType != ratingDetail.scalerType){
        this.raterType = ratingDetail.scalerType;
      }
      this.isNps = (this.raterType == 3 || this.raterType == 10)
      if (this.checkRequiredData()) {
        
        this.prepareDropDownOption(Object.values(this.filterNameMap)).then(() => {
          // this.dropdownOptionChange(this.selectedRowFilter, 'row');
          this.dynamicColumns = [];
          this.dynamicColumnKeys = [];
          this.filterObj.next = this.selectedRowFilter;
          this.filterObj.appliedfilters = [];
          this.performersColumns = this.getPerformersColumn();
          this.getOverallSumary();
        });
      }
    })
  }
  checkRequiredData() {
    if (this.accountDetails && !_.isEmpty(this.accountDetails) && this.from && this.to && this.raterType && (this.projectType != undefined || this.projectType != '')) {
      return true;
    } else {
      return false;
    }
  }

  private refreshComparisonLabels(): void {
    this.dateType =
      _.get(Helpers, 'datePicker.trendType') ||
      _.get(Helpers, 'datePicker.selectedTrend') ||
      'period';
    this.comparisonPeriodLabel = getComparisonPeriodLabel();
    this.isComparisonAvailable = isComparisonAvailable();
    if (!this.isComparisonAvailable) {
      this.showComparisonFlag = false;
      setShowComparisonFlag(false);
      this.showComparisonFlagChange.emit(false);
    } else {
      this.showComparisonFlag = getShowComparisonFlag();
      this.showComparisonFlagChange.emit(this.showComparisonFlag);
    }
  }

  private attachOverviewCellDeviations(rowObject: any, summaryNode: any, columnKey?: string): void {
    if (!summaryNode) {
      return;
    }
    const columnMap = columnKey ? { rating: columnKey } : { rating: 'total' };
    attachSummaryDeviations(
      rowObject,
      _.get(summaryNode, 'summary.current'),
      _.get(summaryNode, 'summary.previous'),
      this.isNps,
      columnMap
    );
  }

  private attachPerformerDeviations(rowObject: any, rowData: any): void {
    attachMetricDeviations(
      rowObject,
      getAccountSummaryMetrics(_.get(rowData, 'summary.current'), this.isNps),
      getAccountSummaryMetrics(_.get(rowData, 'summary.previous'), this.isNps),
      { rating: 'score', responses: 'formated_number_of_users_rated' }
    );
  }
  
  setDropdownConfigWidth(width: string) {
    this.rowDropdown.config.width = width;
    this.columnDropdown.config.width = width;
  }

  changeTableView(event: any, tableView: string) {
    event.preventDefault();
    if (this.selectedTableView != tableView) {
      this.selectedTableView = tableView;
      if (tableView == 'list') {
        this.ddTableConfig.showHeatMap = false;
        this.setDropdownConfigWidth('218px')
      } else if (tableView == 'heatmap') {
        this.ddTableConfig.showHeatMap = true;
        this.ddTableConfig.hideText = false;
        if (!this.drillDownCardFullScreen) {
          this.setDropdownConfigWidth('160px')
        }
      }
    }

  }
  getWidgetConfig(type: string): any {
    return {
      isFullScreenButtonShow: (type == 'drilldown') ? true : false,
      isDownloadButtonShow: true,
      isTrendDropdownShow: false,
      isAbsoluteChartShow: false,
      isPercenttageChartShow: false,
    };
  }

  showFeedsby(event: any) {
    event.preventDefault();
    if (this.ddTableConfig.hideText) {
      this.ddTableConfig.hideText = false;
    } else {
      this.ddTableConfig.hideText = true;
    }
  }

  prepareDropDownOption(fieldDefinitions: any) {
    return new Promise((resolve, reject) => {
      let filters: any = []
      let filterNameMap: any = {};
      if (fieldDefinitions && fieldDefinitions.length) {
        filters.push({
          'name': 'Projects',
          'field_id': 'project',
          'type': 'project'
        });



        _.each(fieldDefinitions, (field: any) => {
          if (field.compare_filter == true) {
            let object: any = Helpers.deepClone(field);
            if (field && field.child && !_.isEmpty(field.child)) {
              field.child = this.prepareChildFilter(field.child, this.filterNameMap)
            }
            object.type = 'tag'
            filters.push(object)
          }
        })
        this.filters = Helpers.deepClone(filters);
      }

      if (filters.length >= 2) {
        if (this.displayProjectAsDefaultColumn) {
          this.selectedRowFilter = filters[1];
          this.selectedColumnFilter = filters[0]
        } else {
          this.selectedRowFilter = filters[0];
          this.selectedColumnFilter = filters[1]
        }

        if (this.selectedRowFilter.field_id == 'project') {
          if (_.has(this, 'projectType')) {
            this.filterObj.next = this.nextProject;
          } else {
            this.filterObj.next = this.nextProjectType;
          }
        } else if (this.selectedRowFilter.type == 'tag') {
          this.filterObj.next = this.selectedRowFilter;
        }
        this.rowDropdown.selectedOption = this.selectedRowFilter.name;
        this.columnDropdown.selectedOption = this.selectedColumnFilter.name;
        this.rowDropdown.options = _.filter(Helpers.deepClone(filters), (field: any) => {
          return field.field_id != this.selectedColumnFilter.field_id
        });
        this.columnDropdown.options = _.filter(Helpers.deepClone(filters), (field: any) => {
          return field.field_id != this.selectedRowFilter.field_id
        });
        this.prepareDrilldownSequence().then(() => {
          resolve(true);
        });
      } else {
        resolve(true);
      }
    })

  }

  prepareDrilldownSequence() {
    return new Promise((resolve, reject) => {
      let sequnce: any = [];
      if (!_.isEmpty(this.selectedRowFilter)) {
        sequnce.push({
          "field_id": this.selectedRowFilter.field_id,
          "name": this.selectedRowFilter.name,
          "field_type": this.selectedRowFilter.field_type,
          "type": this.selectedRowFilter.type,
          "dd_level": 0,
          "selected_value": null,
          "values": []
        })
        if (this.selectedRowFilter.child && !_.isEmpty(this.selectedRowFilter.child)) {
          sequnce = this.getChildSequence(1, this.selectedRowFilter.child, sequnce)
        }
      }
      this.drilldownSequence = sequnce;
      resolve(true);
    })

  }

  getChildSequence(level: number, filter: any, sequnce: any) {
    if (filter && !_.isEmpty(filter)) {
      sequnce.push({
        "field_id": filter.field_id,
        "name": filter.name || this.filterNameMap[filter.field_id].name,
        "field_type": filter.field_type || this.filterNameMap[filter.field_id].field_type,
        "type": filter.type || this.filterNameMap[filter.field_id].type,
        "dd_level": level,
        "selected_value": null,
        "values": []
      })
      if (filter.child && !_.isEmpty(filter.child)) {
        sequnce = this.getChildSequence(level + 1, filter.child, sequnce)
      }
    }
    return sequnce;
  }

  prepareChildFilter(filters: any, filterNameMap: any) {
    if (filters && !_.isEmpty(filters)) {
      if (filterNameMap && filters && filters.field_id && filterNameMap[filters.field_id]) {
        filters.name = filterNameMap[filters.field_id].name
      }
      filters.type = filters.field_type;
      if (filters && filters.child && !_.isEmpty(filters.child)) {
        filters.child = this.prepareChildFilter(filters.child, filterNameMap)
      }
    }
    return filters;
  }

  dropdownOptionChange(event: any, viewBy: any) {
    if (event.field_id != this.selectedRowFilter.field_id && event.field_id != this.selectedColumnFilter.field_id) {
      if (viewBy == 'row') {
        this.selectedRowFilter = event;
        this.rowDropdown.selectedOption = this.selectedRowFilter.name;
        if (this.selectedRowFilter.field_id == 'project') {
          if (_.has(Helpers, 'projectType')) {
            this.filterObj.next = this.nextProject;
          } else {
            this.filterObj.next = this.nextProjectType;
          }
        } else if (this.selectedRowFilter.type == 'tag') {
          this.filterObj.next = event;
        }
      }
      if (viewBy == 'column') {
        this.selectedColumnFilter = event;
        this.columnDropdown.selectedOption = this.selectedColumnFilter.name;
      }
      this.rowDropdown.options = _.filter(Helpers.deepClone(this.filters), (field: any) => {
        return field.field_id != this.selectedColumnFilter.field_id
      });
      this.columnDropdown.options = _.filter(Helpers.deepClone(this.filters), (field: any) => {
        return field.field_id != this.selectedRowFilter.field_id
      });
      this.dynamicColumns = [];
      this.dynamicColumnKeys = [];
      this.filterObj.next = this.selectedRowFilter;
      this.filterObj.appliedfilters = [];
      this.prepareDrilldownSequence().then(() => {
        this.getOverallSumary();
      });
    }
  }

  getOverallSumary() {
    this.isDrilldownDataLoading = true;
    this.isOverallDataLoading = true;
    this.isPerformerDataLoading = true;
    let params: any = {
      "from": this.from,
      "to": this.to,
      "account_id": this.accountId,
      "rater_type": this.raterType,
      "is_custom_date_range_selected": this.isCustomDateRangeSelected,

      "field_id_1": this.selectedColumnFilter.field_id,
      "field_type_1": this.selectedColumnFilter.type
    }
    if (this.projectType != 0) {
      params["project_type"] = this.projectType;
    }
    if (!_.isEmpty(this.universalFilter)) {
      params.universal_filter = this.universalFilter
    }
    this.applyComparisonApiDateRange(params);
    this._analytics.getAccountCrossTab(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      if (_.get(response, 'data.code') == 0 && _.has(response, 'data.overall_summary_details') && !_.isEmpty(response.data.overall_summary_details)) {
        this.processOverallSummary(response.data.overall_summary_details)
      } else {
        this.isOverallDataAvailable = false;
        this.isOverallDataLoading = false;
        this.isDrilldownDataAvailable = false;
        this.isDrilldownDataLoading = false;
        this.isPerformerDataAvailable = false;
        this.isPerformerDataLoading = false;
      }
    }, (error: any) => {
      this.isOverallDataAvailable = false;
      this.isOverallDataLoading = false;
      this.isDrilldownDataAvailable = false;
      this.isDrilldownDataLoading = false;
      this.isPerformerDataAvailable = false;
      this.isPerformerDataLoading = false;
      console.error("Error: ", error)
    })
  }

  processOverallSummary(data: any) {
    let totalNPS: any = 'NA'
    let rows: any = [];
    let promoters: any = 0;
    let passives: any = 0;
    let detractors: any = 0;
    let defaultColumns: any = this.getDefaultColumn("Account Name");
    const isRowExpanded: boolean = (!_.isEmpty(this.drilldownSequence) && !_.isEmpty(this.drilldownSequence[0].expanded_row)) ? true : false;
    const isRowSelected: boolean = (!_.isEmpty(this.drilldownSequence) && !_.isEmpty(this.drilldownSequence[0].selected_value)) ? true : false;
    if ((this.raterType == 3 || this.raterType == 10) && data && _.has(data, 'summary.current') && !_.isEmpty(data.summary.current)) {
      totalNPS = this.getNpsScore(data.summary.current)
      promoters = data.summary.current.promoters;
      passives = data.summary.current.passives;
      detractors = data.summary.current.detractors;
    } else {
      totalNPS = _.get(data, 'summary.current.average_rating', 'NA')
      promoters = 0;
      passives = 0;
      detractors = 0;
      if ((totalNPS % 1) > 0) {
        totalNPS = parseFloat(totalNPS.toFixed(1));
      }
    }


    let rowObject: any = {
      name: this.accountDetails.display_name || this.accountDetails.name,
      key: this.accountId,
      total: totalNPS,
      promoters,
      detractors,
      passives,
      heatMap: {},
      heatMapTextColor: {}
    }
    this.attachOverviewCellDeviations(rowObject, data);

    if (data && data.field_1 && !_.isEmpty(data.field_1)) {
      let columnDetails = this.prepareDynamicColumns(data)

      this.dynamicColumns = columnDetails.columns;
      this.dynamicColumnKeys = columnDetails.columnKeys
      _.each(this.dynamicColumnKeys, (columnKey: any) => {
        if (data && data.field_1 && data.field_1[columnKey]) {
          const columnData: any = data.field_1[columnKey]
          let columnNPS: any = 'NA'
          if (this.isNps && columnData && _.has(columnData, 'summary.current') && !_.isEmpty(columnData.summary.current)) {
            columnNPS = this.getNpsScore(columnData.summary.current)
          } else {
            columnNPS = _.get(columnData, 'summary.current.average_rating', 'NA')
            if ((columnNPS % 1) > 0) {
              columnNPS = parseFloat(columnNPS.toFixed(1));
            }
          }
          rowObject[columnKey] = columnNPS;
          const colorDetail = this.getHeatMapColor(rowObject[columnKey])
          rowObject.heatMap[columnKey] = colorDetail.bgColor;
          if (rowObject[columnKey] != 'NA') {
            rowObject.heatMapTextColor[columnKey] = colorDetail.textColor
          }
          this.attachOverviewCellDeviations(rowObject, columnData, columnKey);
        } else if (columnKey) {
          rowObject[columnKey] = 'NA'
        }
      })
      if (!isRowExpanded && !isRowSelected) {
        this.overallScore = totalNPS;
        this.overallScorekey = this.accountId
        this.selectedRow = rowObject
      }


    }

    const doc_count = _.get(data, 'summary.current.doc_count');
    // if (doc_count && doc_count > 0) {
    if (true) {

      rows.push(rowObject);
      if (isRowExpanded) {
        this.getDrillDownData()
      } else {
        this.getChildSummary();
        this.getTopAndBottomPerformers();
      }


      this.overallTable.fixedHeader = defaultColumns;
      this.overallTable.header = this.dynamicColumns || [];
      this.overallTable.row = rows;
      this.isOverallDataAvailable = true;
      this.isOverallDataLoading = false;
    } else {
      this.isOverallDataAvailable = false;
      this.isOverallDataLoading = false;
      this.isDrilldownDataAvailable = false;
      this.isDrilldownDataLoading = false;
      this.isPerformerDataAvailable = false;
      this.isPerformerDataLoading = false;
    }






  }

  getDrillDownData() {
    let apiCalls: any = {};
    _.each(this.drilldownSequence, (data: any) => {
      const isRowExpanded: boolean = (!_.isEmpty(this.drilldownSequence) && !_.isEmpty(this.drilldownSequence[0].expanded_row)) ? true : false;
      if (data && !_.isEmpty(data.query) && isRowExpanded) {
        data.query.from = this.from;
        data.query.to = this.to;
        if (!_.isEmpty(this.universalFilter)) {
          data.query.universal_filter = this.universalFilter
        }
        apiCalls[data.field_id] = this._analytics.getAccountCrossTab(data.query);
      }
    })
    forkJoin(apiCalls).subscribe((response: any) => {
      this.mapDrilldownData(response)
    })
  }

  selectedData: any = {
    score: null,
    row: null
  }

  mapDrilldownData(response: any) {
    let rows: any = [];
    this.selectedData = {
      score: null,
      row: null
    }

    if (!_.isEmpty(this.selectedRowFilter)) {
      const hasChild = (this.selectedRowFilter.child && !_.isEmpty(this.selectedRowFilter.child)) ? true : false;
      const seqData = _.find(this.drilldownSequence, { field_id: this.selectedRowFilter.field_id })
      rows = this.getProcessDrillDownData(seqData, response[seqData.field_id], hasChild, this.selectedRowFilter.child);

      if (hasChild && seqData && !_.isEmpty(seqData.expanded_row)) {
        const index = _.findIndex(rows, { 'value': seqData.expanded_row.key })
        rows[index].isExpanded = true
        rows[index].fixedHeader = this.getDefaultColumn(seqData.name);;
        rows[index].header = this.dynamicColumns;
        rows[index].drilldown = this.mapChildResponse(this.selectedRowFilter.child, response);
      }

      if (_.isEmpty(this.selectedData.row) && seqData && !_.isEmpty(seqData.selected_value)) {
        const index = _.findIndex(rows, { 'value': seqData.selected_value.key })
        this.selectedData = { score: (rows[index].total != 'NA') ? rows[index].total : null, row: rows[index] }
      }
    }
    this.drilldownTable.row = [...rows];
    this.selectedRow = this.selectedData.row;
    this.overallScore = this.selectedData.score;
    this.getTopAndBottomPerformers();
    this.isDrilldownDataAvailable = true;
    this.isDrilldownDataLoading = false;

  }

  mapChildResponse(filter: any, response: any) {
    let rows: any = [];
    if (!_.isEmpty(filter)) {
      const hasChild = (filter.child && !_.isEmpty(filter.child)) ? true : false;
      const seqData = _.find(this.drilldownSequence, { field_id: filter.field_id })
      rows = this.getProcessDrillDownData(seqData, response[seqData.field_id], hasChild, filter.child);
      if (hasChild && seqData && !_.isEmpty(seqData.expanded_row)) {
        const index = _.findIndex(rows, { 'value': seqData.expanded_row.key })
        rows[index].isExpanded = true
        rows[index].fixedHeader = this.getDefaultColumn(seqData.name);;
        rows[index].header = this.dynamicColumns;
        rows[index].drilldown = this.mapChildResponse(filter.child, response);
      }
      if (_.isEmpty(this.selectedData.row) && seqData && !_.isEmpty(seqData.selected_value)) {
        const index = _.findIndex(rows, { 'value': seqData.selected_value.key })
        this.selectedData = { score: (rows[index].total != 'NA') ? rows[index].total : null, row: rows[index] }
      }
    }
    return rows
  }

  getProcessDrillDownData(seqData: any, res: any, hasChild: boolean, child?: any) {
    const rows: any = []
    let rowKeys: any = _.map(seqData.values, (obj: any) => obj.key);
    if (_.get(res, 'data.code') == 0 && _.has(res, 'data.overall_summary_details') && !_.isEmpty(res.data.overall_summary_details)) {
      const data = res.data.overall_summary_details
      _.each(data.field_1, (value: any, key: any) => {
        if (rowKeys.indexOf(key) < 0) {
          rowKeys.push(key)
        }
      });

      if (seqData.field_id == "project") {
        _.each(data.brands, (value, key) => {
          if (rowKeys.indexOf(key) < 0) {
            rowKeys.push(key)
          }
        });
      }

      _.each(rowKeys, (rowKey: string) => {
        let rowData = data.field_1[rowKey]
        let totalNPS: any = 'NA';
        let promoters: any = 0;
        let passives: any = 0;
        let detractors: any = 0

        if (this.isNps && rowData && _.has(rowData, 'summary.current') && !_.has(rowData.summary.current)) {
          totalNPS = this.getNpsScore(rowData.summary.current);
          promoters = rowData.summary.current.promoters;
          passives = rowData.summary.current.passives;
          detractors = rowData.summary.current.detractors;
        } else {
          totalNPS = _.get(rowData, 'summary.current.average_rating', 'NA')
          promoters = 0;
          passives = 0;
          detractors = 0;
        }

        let name = (_.has(data, "brands." + rowKey + ".name")) ? _.get(data, "brands." + rowKey + ".name", rowKey) : rowKey;
        let uniqueKey = (_.has(this.filterObj, 'next.field_id') && _.get(this.filterObj, 'next.field_id') != 'project') ? this.filterObj.next.field_id + "_" + rowKey : rowKey;
        uniqueKey = uniqueKey.split(" ").join("_")
        let rowObject: any = {
          name: name,
          value: rowKey,
          level: seqData.dd_level,
          key: this.removeSpecialChar(uniqueKey),
          total: totalNPS,
          promoters,
          detractors,
          passives,
          heatMap: {},
          heatMapTextColor: {},
        }
        if (this.overallScorekey == rowKey) {
          this.overallScore = (totalNPS != "NA") ? totalNPS : null;
        }
        rowObject.field_id = seqData.field_id;
        rowObject.field_type = seqData.type;
        rowObject.field_name = seqData.name;
        if (hasChild) {
          rowObject.drilldown = [];
          rowObject.next = child;
        }
        _.each(this.dynamicColumnKeys, (key: string) => {

          if (key && _.has(rowData, 'field_2.' + key + '.summary.current') && !_.isEmpty(rowData.field_2[key].summary.current)) {
            const columnData = rowData.field_2[key].summary.current;
            if (this.isNps) {
              rowObject[key] = this.getNpsScore(columnData)
            } else {
              rowObject[key] = _.get(columnData, 'average_rating', 'NA')
              if ((rowObject[key] % 1) > 0) {
                rowObject[key] = parseFloat(rowObject[key].toFixed(1));
              }
            }
          } else {
            rowObject[key] = 'NA'
          }
          const colorDetails = this.getHeatMapColor(rowObject[key])
          rowObject.heatMap[key] = colorDetails.bgColor;
          if (rowObject[key] != 'NA') {
            rowObject.heatMapTextColor[key] = colorDetails.textColor
          }

        })
        this.attachOverviewCellDeviations(rowObject, rowData);
        _.each(this.dynamicColumnKeys, (key: string) => {
          if (key && _.has(rowData, 'field_2.' + key)) {
            this.attachOverviewCellDeviations(rowObject, rowData.field_2[key], key);
          }
        });
        rows.push(rowObject)
      });
    } else {
      _.each(seqData.values, (obj: any) => {
        let totalNPS: any = 'NA';
        let promoters: any = 0;
        let passives: any = 0;
        let detractors: any = 0
        let name = obj.name;
        let uniqueKey = (_.has(seqData, 'field_id') && _.get(seqData, 'field_id') != 'project') ? seqData.field_id + "_" + obj.key : obj.key;
        uniqueKey = uniqueKey.split(" ").join("_")
        let rowObject: any = {
          name: name,
          value: obj.key,
          level: seqData.dd_level,
          key: this.removeSpecialChar(uniqueKey),
          total: totalNPS,
          promoters,
          detractors,
          passives,
          heatMap: {},
          heatMapTextColor: {},
        }
        if (this.overallScorekey == obj.key) {
          this.overallScore = (totalNPS != "NA") ? totalNPS : null;
        }
        if (hasChild) {
          rowObject.drilldown = [];
          rowObject.next = child;
        }
        rowObject.field_id = seqData.field_id;
        rowObject.field_type = seqData.type;
        rowObject.field_name = seqData.name;
        _.each(this.dynamicColumnKeys, (key: string) => {
          rowObject[key] = 'NA'
          const colorDetails = this.getHeatMapColor(rowObject[key])
          rowObject.heatMap[key] = colorDetails.bgColor;
        })
        rows.push(rowObject)
      })
    }
    return rows;
  }



  prepareDynamicColumns(summary: any) {
    const columnKeys = (summary && summary.field_1 && !_.isEmpty(summary.field_1)) ? Object.keys(summary.field_1) : [];
    let columns: any = [];
    let columnFieldMap: any = {}
    if (columnKeys.length) {
      _.each(columnKeys, (columnKey: any) => {
        if (!columnFieldMap[columnKey]) {

          const header: string = (_.has(summary, 'brands.' + columnKey + ".name")) ? _.get(summary, 'brands.' + columnKey + ".name", columnKey) : columnKey;
          columnFieldMap[columnKey] = header
          columns.push({
            uniqueId: columnKey,
            header: header,
            width: '126px',
            minWidth: '126px',
            maxWidth: '126px',
            isSortingEnabled: true,
            order: _.get(summary.field_1, columnKey + '.summary.current.doc_count', 0),
            style: {
              header: 'flex-end',
              row: 'flex-end'
            }
          })
        }

      })
      if (summary && summary.brands && !_.isEmpty(summary.brands) && this.selectedColumnFilter && this.selectedColumnFilter.type == "project") {
        _.each(summary.brands, (detail: any, columnKey: string) => {
          if (!columnFieldMap[columnKey]) {
            columnFieldMap[columnKey] = detail.name
            columns.push({
              uniqueId: columnKey,
              header: detail.name,
              width: '126px',
              minWidth: '126px',
              maxWidth: '126px',
              isSortingEnabled: true,
              order: 0,
              style: {
                header: 'flex-end',
                row: 'flex-end'
              }
            })
          }
        })
      }
      columns = _.sortBy(columns, 'order');
      columns = columns.reverse();
      return {
        columns: columns,
        columnKeys: _.map(columns, (column: any) => column.uniqueId)
      }
    } else {
      return {
        columns: [],
        columnKeys: []
      }
    }
  }

  getChildSummary(event?: any, appliedfilters?: any) {
    if (!event) this.isDrilldownDataLoading = true;
    let level: number = (!event || _.isEmpty(event)) ? 0 : event.level + 1;
    const params: any = {
      "from": this.from,
      "to": this.to,
      "account_id": this.accountId,
      "rater_type": this.raterType,
      "is_custom_date_range_selected": this.isCustomDateRangeSelected,
      "field_id_1": (_.has(this.filterObj, 'next.field_id')) ? this.filterObj.next.field_id : this.selectedRowFilter.field_id,
      "field_type_1": (_.has(this.filterObj, 'next.type')) ? this.filterObj.next.type : this.selectedRowFilter.type,
      "field_id_2": this.selectedColumnFilter.field_id,
      "field_type_2": this.selectedColumnFilter.type
    }
    if (this.projectType && this.projectType > 0) {
      params["project_type"] = this.projectType;
    }
    if (_.has(event, 'filters') && !_.isEmpty(event.filters)) {
      params.cohorts_filter = Helpers.deepClone(event.filters);
    }
    if (!_.isEmpty(this.universalFilter)) {
      params.universal_filter = this.universalFilter
    }
    this.drilldownSequence[level].query = Helpers.deepClone(params)
    this.applyComparisonApiDateRange(params);
    this._analytics.getAccountCrossTab(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      if (_.get(response, 'data.code') == 0 && _.has(response, 'data.overall_summary_details') && !_.isEmpty(response.data.overall_summary_details)) {
        this.processChildData(response.data.overall_summary_details, event, appliedfilters)
      } else {
        if (event) {
          event.isLoading = false;
        } else {
          this.isDrilldownDataAvailable = false;
          this.isDrilldownDataLoading = false;
        }

      }

    }, (error: any) => {
      console.error("Error: ", error)
    })
  }

  processChildData(data: any, event?: any, appliedfilters?: any) {
    let rows: any = []
    let rowKeys: any = [];
    let level: number = (!event || _.isEmpty(event)) ? 0 : event.level + 1;
    if (data && ((data.field_1 && !_.isEmpty(data.field_1)) || (data.brands && !_.isEmpty(data.brands)))) {
      let fieldName = this.filterObj?.next?.name;
      let fieldId = this.filterObj?.next?.field_id;
      if (!fieldName && fieldId && this.filterNameMap[fieldId]) {
        fieldName = this.filterNameMap[fieldId].name;
      }
      const defaultColumns = this.getDefaultColumn(fieldName);
      this.ddTableConfig.style = {
        width: (this.dynamicColumns && this.dynamicColumns.length) ? (this.dynamicColumns.length * 126) + 'px' : ''
      }
      rowKeys = _.keys(data.field_1);
      if (this.selectedRowFilter.field_id == "project") {
        rowKeys = _.keys(data.brands)
      }
      _.each(rowKeys, (rowKey: string) => {
        let rowData = data.field_1[rowKey]
        let totalNPS: any = 'NA';
        let promoters: any = 0;
        let passives: any = 0;
        let detractors: any = 0

        if (this.isNps && rowData && _.has(rowData, 'summary.current') && !_.has(rowData.summary.current)) {
          totalNPS = this.getNpsScore(rowData.summary.current);
          promoters = rowData.summary.current.promoters;
          passives = rowData.summary.current.passives;
          detractors = rowData.summary.current.detractors;
        } else {
          totalNPS = _.get(rowData, 'summary.current.average_rating', 'NA')
          promoters = 0;
          passives = 0;
          detractors = 0;
          if ((totalNPS % 1) > 0) {
            totalNPS = parseFloat(totalNPS.toFixed(1));
          }
        }

        let name = (_.has(data, "brands." + rowKey + ".name")) ? _.get(data, "brands." + rowKey + ".name", rowKey) : rowKey;
        let uniqueKey = (_.has(this.filterObj, 'next.field_id') && _.get(this.filterObj, 'next.field_id') != 'project') ? this.filterObj.next.field_id + "_" + rowKey : rowKey;
        uniqueKey = uniqueKey.split(" ").join("_")
        this.drilldownSequence[level].values.push({ "key": rowKey, "name": name })
        this.drilldownSequence[level].values = _.uniqBy(this.drilldownSequence[level].values, 'key');
        let rowObject: any = {
          name: name,
          value: rowKey,
          level: level,
          key: this.removeSpecialChar(uniqueKey),
          total: totalNPS,
          promoters,
          detractors,
          passives,
          heatMap: {},
          heatMapTextColor: {},
        }

        if (_.has(this.filterObj, 'next.child') && !_.isEmpty(this.filterObj.next.child)) {
          rowObject.drilldown = []
          rowObject.next = this.filterObj.next.child;
        }

        if (_.has(event, 'filters') && !_.isEmpty(event.filters)) {
          rowObject.filters = Helpers.deepClone(event.filters);
        }

        if (_.has(this.filterObj, 'next.field_id')) {
          rowObject.field_id = this.filterObj.next.field_id;
          rowObject.field_type = this.filterObj.next.type;
          rowObject.field_name = this.filterObj.next.name;
        } else {
          rowObject.field_id = this.selectedRowFilter.field_id;
          rowObject.field_type = this.selectedRowFilter.type;
          rowObject.field_name = this.selectedRowFilter.name;
        }

        if (this.dynamicColumnKeys && this.dynamicColumnKeys.length) {
          _.each(this.dynamicColumnKeys, (key: string) => {

            if (key && _.has(rowData, 'field_2.' + key + '.summary.current') && !_.isEmpty(rowData.field_2[key].summary.current)) {
              const columnData = rowData.field_2[key].summary.current;
              if (this.isNps) {
                rowObject[key] = this.getNpsScore(columnData)
              } else {
                rowObject[key] = _.get(columnData, 'average_rating', 'NA')
                if ((rowObject[key] % 1) > 0) {
                  rowObject[key] = parseFloat(rowObject[key].toFixed(1));
                }
              }
            } else {
              rowObject[key] = 'NA'
            }
            const colorDetails = this.getHeatMapColor(rowObject[key])
            rowObject.heatMap[key] = colorDetails.bgColor;
            if (rowObject[key] != 'NA') {
              rowObject.heatMapTextColor[key] = colorDetails.textColor
            }

          })
        }

        this.attachOverviewCellDeviations(rowObject, rowData);
        if (this.dynamicColumnKeys && this.dynamicColumnKeys.length) {
          _.each(this.dynamicColumnKeys, (key: string) => {
            if (key && _.has(rowData, 'field_2.' + key)) {
              this.attachOverviewCellDeviations(rowObject, rowData.field_2[key], key);
            }
          });
        }

        rows.push(rowObject)
      });




      if (event?.drilldown) {
        event.fixedHeader = defaultColumns;
        event.header = this.dynamicColumns;
        event.drilldown = rows;
        event.isLoading = false;
      } else {
        this.drilldownTable.fixedHeader = defaultColumns;
        this.drilldownTable.header = this.dynamicColumns;
        this.drilldownTable.row = rows;
        if (rows && rows.length) {
          this.isDrilldownDataAvailable = true;
        } else {
          this.isDrilldownDataAvailable = false;
        }
        this.isDrilldownDataLoading = false;
      }
    } else {

      if (event) {
        event.isLoading = false;
      } else {
        this.isDrilldownDataAvailable = false;
        this.isDrilldownDataLoading = false;
      }

    }
  }

  removeSpecialChar(str: string) {
    return str.replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
  }

  getHeatMapColor(score: any,) {
    let bgColor: string = '#FFFFFF'
    let textColor: string = '#000000'
    const raterDetails = this._helpers.getRaterDetails(this.raterType);
    if (score != 'NA') {
      let hue = 0;
      let saturation = 100;
      let lightness = 50;
      if (this.isNps) {
        if (score >= -100 && score < 0) {
          hue = 0
          lightness = 80 - Math.round((0.45 * Math.abs(score)))
          if (lightness <= 55) {
            textColor = "#FFFFFF"
          }
        } else if (score >= 0 && score <= 30) {
          hue = 40
          lightness = 50 + score
        } else if (score >= 31 && score <= 100) {
          hue = 100
          lightness = 80 - Math.round((0.45 * score))
          if (lightness <= 50) {
            textColor = "#FFFFFF"
          }
        }
      } else {
        score = (typeof score == 'string') ? parseFloat(score) : score;
        if (raterDetails.min_score >= 0) {
          let percent = (score / raterDetails.max_score) * 100;
          if (percent >= 0 && percent <= 30) {
            hue = 40
            lightness = 50 + percent
            if (lightness <= 55) {
              textColor = "#FFFFFF"
            }
          } else if (percent >= 31 && percent <= 60) {
            hue = 40
            lightness = 80 - Math.round((0.45 * percent))
          } else if (percent >= 61 && percent <= 100) {
            hue = 100
            lightness = 80 - Math.round((0.45 * percent))
            if (lightness <= 50) {
              textColor = "#FFFFFF"
            }
          }
        } else {
          let percent = (score / raterDetails.max_score) * 100;
          if (percent >= -100 && percent < 0) {
            hue = 0
            lightness = 80 - Math.round((0.45 * Math.abs(percent)))
            if (lightness <= 55) {
              textColor = "#FFFFFF"
            }
          } else if (percent >= 0 && percent <= 30) {
            hue = 40
            lightness = 50 + percent
          } else if (percent >= 31 && percent <= 100) {
            hue = 100
            lightness = 80 - Math.round((0.45 * percent))
            if (lightness <= 50) {
              textColor = "#FFFFFF"
            }
          }
        }


      }

      bgColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`
    }
    return { bgColor, textColor };

  }

  getBackgroundAndTextColor(heatMapObj: any, raterDetails: any, raterType: any) {
    heatMapObj.backgroundColor = '#ffffff';
    heatMapObj.textColor = '#000000';
    heatMapObj.brightness = '70%';
    if (raterDetails && raterDetails.distributions && raterDetails.distributions.length) {
      var minValue = raterDetails.min_score;
      var maxValue = raterDetails.max_score;
      var distLen = raterDetails.distributions.length
      var valuesToAdd = (Math.abs(minValue) + Math.abs(maxValue)) / distLen;
      var value = heatMapObj.value;
      if (distLen == 2) {
        if (value >= minValue && value < (minValue + valuesToAdd)) {
          heatMapObj.backgroundColor = raterDetails.distributions[1].color;
          heatMapObj.brightness = 150 + (value * 10);
        } else {
          heatMapObj.backgroundColor = raterDetails.distributions[0].color;
          heatMapObj.brightness = 70 + (value * 10);
        }
      } else if (distLen == 3) {
        if (value >= minValue && value < (minValue + valuesToAdd)) {
          heatMapObj.backgroundColor = raterDetails.distributions[2].color;
          heatMapObj.brightness = 150 + value;
        } else if (value >= (minValue + valuesToAdd) && value < (minValue + (2 * valuesToAdd))) {
          heatMapObj.backgroundColor = raterDetails.distributions[1].color;
          heatMapObj.brightness = 100 + value;
        } else {
          heatMapObj.backgroundColor = raterDetails.distributions[0].color;
          heatMapObj.brightness = 50 + value;
        }
        if (raterType != 3) {
          heatMapObj.brightness = 70 + (value * 10);
        }
      }
      if (heatMapObj.backgroundColor != '#ffffff') {
        heatMapObj.textColor = '#ffffff';
      }
    }
    return heatMapObj;
  }

  getNpsScore(columnData: any) {
    let promoters = (_.has(columnData, 'promoters')) ? _.get(columnData, 'promoters', 0) : 0;
    let detractors = (_.has(columnData, 'detractors')) ? _.get(columnData, 'detractors', 0) : 0;
    let total = (_.has(columnData, 'users_rater_primary_rating')) ? _.get(columnData, 'users_rater_primary_rating', 0) : 0;;
    if (total > 0) {
      if ((promoters > 0 || detractors > 0)) {
        let score = ((promoters / total) * 100) - ((detractors / total) * 100);
        if (score % 1) {
          score = parseFloat(score.toFixed(0));
        }
        return score
      } else {
        return 0
      }

    } else {
      return "NA"
    }
  }

  onDrillDown(event: any, eventType?: string) {
    this.selectedRow = event;
    if (event.isExpanded || eventType == 'overall') {
      if (event?.drilldown && event.field_type != 'project' && eventType == 'drilldown') {
        if (!event?.filters) {
          event.filters = [{
            "field_id": event.field_id,
            "value": event.value,
            "type": event.field_type
          }]
        } else {
          event.filters.push({
            "field_id": event.field_id,
            "value": event.value,
            "type": event.field_type
          })
        }
        this.drilldownSequence[event.level].expanded_row = { "key": event.value, "name": event.name };
        this.drilldownSequence[event.level].selected_value = { "key": event.value, "name": event.name };
        this.overallScore = (event.total != 'NA') ? event.total : null
        this.overallScorekey = event.value
        this.filterObj.appliedfilters = Helpers.deepClone(event.filters);
        this.filterObj.next = event?.next;
        this.getChildSummary(event);
        this.getTopAndBottomPerformers()
      } else {
        this.drilldownSequence = _.map(this.drilldownSequence, (seqData: any) => {
          if (seqData.dd_level >= event.level) {
            delete seqData.expanded_row
            delete seqData.selected_value
            delete seqData.query
          }
          return seqData
        })
        this.overallScorekey = event.value;
        this.overallScore = (event.total != 'NA') ? event.total : null;
        this.filterObj.appliedfilters = [];
        this.filterObj.next = this.selectedRowFilter;
        this.getChildSummary();
        this.getTopAndBottomPerformers()
      }
    } else {
      this.overallScore = (event.total != 'NA') ? event.total : null
      this.overallScorekey = event.value;
      this.drilldownSequence = _.map(this.drilldownSequence, (seqData: any) => {
        if (seqData.dd_level >= event.level) {
          delete seqData.expanded_row
          delete seqData.selected_value
        }
        return seqData
      })

      delete this.drilldownSequence[event.level].expanded_row
      if (this.filterObj.appliedfilters && this.filterObj.appliedfilters.length) {
        const index = _.findIndex(this.filterObj.appliedfilters, { field_id: event.field_id });
        if (index >= 0) {
          this.filterObj.next = this.filterObj.appliedfilters[index];
          this.filterObj.appliedfilters.splice(index, this.filterObj.appliedfilters.length)
        } else {
          this.filterObj.appliedfilters = [];
          this.filterObj.next = this.selectedRowFilter;
        }

      } else {
        this.filterObj.appliedfilters = [];
        this.filterObj.next = this.selectedRowFilter;
      }
      this.getTopAndBottomPerformers();
    }

  }

  onRowSelect(event: any, eventType?: string) {
    this.selectedRow = event;
    if (event?.field_id && event?.key && eventType == 'drilldown') {
      let filters: any = []
      let projectId: any = null;
      if (event.field_type == "project") {
        this.filterObj.appliedfilters = [];
        projectId = event.value
      } else {

        if (!event?.filters) {
          filters = [{
            "field_id": event.field_id,
            "value": event.value,
            "type": this.filterObj.next.type
          }]
        } else {
          filters = Helpers.deepClone(event.filters)
          filters.push({
            "field_id": event.field_id,
            "value": event.value,
            "type": this.filterObj.next.type
          })
        }
        this.filterObj.appliedfilters = Helpers.deepClone(filters);
      }

      this.overallScore = (event.total != 'NA') ? event.total : null;
      this.overallScorekey = event.value;
      this.drilldownSequence[event.level].selected_value = {
        "key": event.value,
        "name": event.name
      }
      this.getTopAndBottomPerformers(projectId)
    } else {
      this.overallScore = (event.total != 'NA') ? event.total : null;
      this.overallScorekey = event.value;
      this.drilldownSequence = _.map(this.drilldownSequence, (seqData: any) => {
        if (seqData.dd_level > event.level) {
          delete seqData.selected_value
        } else if (seqData.dd_level == event.level) {
          seqData.selected_value = {
            "key": event.value,
            "name": event.name
          }
        }
        return seqData
      })
      this.filterObj.appliedfilters = [];
      this.filterObj.next = this.selectedRowFilter;
      this.getChildSummary();
      this.getTopAndBottomPerformers()
    }
  }

  getDefaultColumn(headerName?: string) {
    const defaultColumn = [{
      uniqueId: 'name',
      header: (headerName) ? headerName : this.selectedRowFilter.name,
      width: '300px',
      maxWidth: '300px',
      minWidth: '300px',
      isSortingEnabled: true,
      clickable: true,
      style: {
        header: 'flex-start',
        row: 'flex-start'
      }
    }, {
      uniqueId: 'total',
      header: 'Total',
      width: '120px',
      maxWidth: '120px',
      isSortingEnabled: true,

      style: {
        header: 'flex-end',
        headerTextColor: "#3677FF",
        row: 'flex-end'
      },
      textStyle: {
        fontWeight: '700'
      }
    }];
    return Helpers.deepClone(defaultColumn)
  }

  getTopAndBottomPerformers(projectId?: string) {

    if (!_.isEmpty(this.cohortDetail) && this.cohortDetail.field_id) {
      this.isPerformerDataLoading = true;
      const params: any = {
        "account_id": this.accountId,
        "from": this.from,
        "to": this.to,
        "view_type": "list",
        "rater_type": this.raterType,
        "field_id": this.cohortDetail.field_id,
        "field_type": "tag",
        "is_custom_date_range_selected": this.isCustomDateRangeSelected
      }

      if (projectId && projectId != '') {
        params.brand_id = projectId
      }

      if (_.has(this.filterObj, 'appliedfilters') && !_.isEmpty(this.filterObj.appliedfilters)) {
        params.cohorts_filter = this.filterObj.appliedfilters;
      }

      if (!_.isEmpty(this.universalFilter)) {
        params.universal_filter = this.universalFilter
      }

      this._analytics.getAccountScoresSummary(params).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        if (_.get(response, 'data.code') == 0 && _.has(response, 'data.overall_summary_details.overall_summary') && !_.isEmpty(response.data.overall_summary_details.overall_summary)) {
          this.processTopAndBottomPerformers(response.data.overall_summary_details.overall_summary)
        } else {
          this.isPerformerDataLoading = false;
          this.isPerformerDataAvailable = false;
        }
      }, (error: any) => {
        console.error("Error", error);
        this.isPerformerDataLoading = false;
        this.isPerformerDataAvailable = false;
      })
    } else {
      this.isPerformerDataLoading = false;
      this.isPerformerDataAvailable = false;
    }

  }

  processTopAndBottomPerformers(data: any) {
    let formatedData: any = [];
    if (!_.isEmpty(data)) {
      _.each(data, (rowData: any, rowKey: string) => {
        let rowObject: any = {
          key: rowKey,
          name: rowKey,
          promoters: 0,
          passives: 0,
          detractors: 0,
          promoters_percentage: 0,
          passives_percentage: 0,
          detractors_percentage: 0,
          number_of_users_rated: 0,
          primary_rating_sum: 0,
          average_rating: 0,
          score: 0,
          impact_score: 0
        }
        var impact_score: any = null;
        if (rowData && _.has(rowData, 'summary.current') && !_.isEmpty(rowData.summary.current)) {
          const scoreDetails = _.get(rowData, 'summary.current');
          rowObject.number_of_users_rated = _.get(scoreDetails, 'users_rater_primary_rating', 0);
          rowObject.formated_number_of_users_rated = rowObject.number_of_users_rated.toLocaleString('en-IN')
          rowObject.average_rating = _.get(scoreDetails, 'average_rating', 0);
          rowObject.doc_count = _.get(scoreDetails, 'doc_count', 0);
          rowObject.promoters = _.get(scoreDetails, 'promoters', 0)
          rowObject.passives = _.get(scoreDetails, 'passives', 0)
          rowObject.detractors = _.get(scoreDetails, 'detractors', 0)
          rowObject.top = scoreDetails?.promoters || scoreDetails?.top || scoreDetails?.positives || 0;
          rowObject.mid = scoreDetails?.passives || scoreDetails?.mid || 0;
          rowObject.bottom = scoreDetails?.detractors || scoreDetails?.negatives || scoreDetails?.bottom || 0;
          rowObject.primary_rating_sum = _.get(scoreDetails, 'primary_rating_sum', 0)
          rowObject.score = (this.isNps) ? this.getNpsScore(rowData.summary.current) : _.get(scoreDetails, 'average_rating', 0);
          rowObject.top_percentage = "0%";
          rowObject.mid_percentage = "0%";
          rowObject.bottom_percentage = "0%";

          rowObject.textColor = {
            promoters_percentage: "#0A7139",
            passives_percentage: "#F3801F",
            detractors_percentage: "#ED2524",
            top_percentage: "#0A7139",
            mid_percentage: "#F3801F",
            bottom_percentage: "#ED2524",
          }
          if (rowObject.score != null && this.overallScore != null) {
            impact_score = (rowObject.score - this.overallScore) * rowObject.number_of_users_rated;
          }
          if (rowObject.promoters > 0 && rowObject.number_of_users_rated > 0) {
            rowObject.promoters_percentage = (rowObject.promoters / rowObject.number_of_users_rated) * 100
            if ((rowObject.promoters_percentage % 1) > 0) {
              rowObject.promoters_percentage = parseInt(rowObject.promoters_percentage.toFixed(0));
            }
            rowObject.promoters_percentage = rowObject.promoters_percentage + "%";
          }
          if (rowObject.passives > 0 && rowObject.number_of_users_rated > 0) {
            rowObject.passives_percentage = (rowObject.passives / rowObject.number_of_users_rated) * 100
            if ((rowObject.passives_percentage % 1) > 0) {
              rowObject.passives_percentage = parseInt(rowObject.passives_percentage.toFixed(0));
            }
            rowObject.passives_percentage = rowObject.passives_percentage + "%";
          }
          if (rowObject.detractors > 0 && rowObject.number_of_users_rated > 0) {
            rowObject.detractors_percentage = (rowObject.detractors / rowObject.number_of_users_rated) * 100
            if ((rowObject.detractors_percentage % 1) > 0) {
              rowObject.detractors_percentage = parseInt(rowObject.detractors_percentage.toFixed(0));
            }
            rowObject.detractors_percentage = rowObject.detractors_percentage + "%";
          }

          if (rowObject.top > 0 && rowObject.number_of_users_rated > 0) {
            rowObject.top_percentage = (rowObject.top / rowObject.number_of_users_rated) * 100
            if ((rowObject.top_percentage % 1) > 0) {
              rowObject.top_percentage = parseInt(rowObject.top_percentage.toFixed(0));
            }
            rowObject.top_percentage = rowObject.top_percentage + "%";
          }
          if (rowObject.mid > 0 && rowObject.number_of_users_rated > 0) {
            rowObject.mid_percentage = (rowObject.mid / rowObject.number_of_users_rated) * 100
            if ((rowObject.mid_percentage % 1) > 0) {
              rowObject.mid_percentage = parseInt(rowObject.mid_percentage.toFixed(0));
            }
            rowObject.mid_percentage = rowObject.mid_percentage + "%";
          }

          if (rowObject.bottom > 0 && rowObject.number_of_users_rated > 0) {
            rowObject.bottom_percentage = (rowObject.bottom / rowObject.number_of_users_rated) * 100
            if ((rowObject.bottom_percentage % 1) > 0) {
              rowObject.bottom_percentage = parseInt(rowObject.bottom_percentage.toFixed(0));
            }
            rowObject.bottom_percentage = rowObject.bottom_percentage + "%";
          }

          rowObject.impact_score = impact_score;
        }
        this.attachPerformerDeviations(rowObject, rowData);
        formatedData.push(rowObject);
      })

      if (formatedData && formatedData.length) {
        formatedData = _.orderBy(formatedData, ['doc_count'], ['asc']);
        formatedData = _.filter(formatedData, (resp) => {
          return resp.doc_count;
        });
        // Sort response by number of records
        formatedData = _.orderBy(formatedData, ['impact_score'], ['asc']);
        if (formatedData && formatedData.length) {
          let finalResponse = JSON.parse(JSON.stringify(formatedData));
          this.bottomResponses = finalResponse.splice(0, 5);
          formatedData = formatedData.reverse();
          this.topResponses = formatedData.splice(0, 5);
          this.isPerformerDataAvailable = true;
        } else {
          this.isPerformerDataAvailable = false;
        }
      } else {
        this.isPerformerDataAvailable = false;
      }
    } else {
      this.isPerformerDataAvailable = false;
    }
    this.isPerformerDataLoading = false;

  }

  getPerformersColumn(isExportColumns?: boolean) {
    const headerLabels = this.creatingLabels();
    let scoreLabel: any = (this.raterType == 3) ? (headerLabels.display || this._helpers.getDisplayLabel('Score')) : (headerLabels.rating || this._helpers.getDisplayLabel('Rating'));
    // need to update if lable config is required.
    // if (false) {
    //   scoreLabel = 'Score'
    // }
    const defaultColumn = [{
      uniqueId: 'name',
      header: "Name",
      width: '130px',
      maxWidth: '130px',
      style: {
        header: 'flex-start',
        row: 'flex-start'
      }
    }, {
      uniqueId: 'score',
      header: scoreLabel,
      width: '100px',
      maxWidth: '100px',
      style: {
        header: 'flex-end',
        row: 'flex-end'
      }
    }, {
      uniqueId: 'formated_number_of_users_rated',
      header: 'Responses',
      sortId: 'number_of_users_rated',
      width: '120px',
      maxWidth: '120px',
      style: {
        header: 'flex-end',
        row: 'flex-end'
      }
    }];
    let distributionColumns: any = [];
    let distributionPercentageColumns: any = [];
    if (this.isNps) {
      distributionColumns = [{
        uniqueId: 'promoters',
        header: 'Promoters',
        width: '120px',
        maxWidth: '120px',
        isHeaderTextHide: true,
        image: 'assets/images/promoters.svg',
        style: {
          header: 'flex-end',
          row: 'flex-end'
        },
        textStyle: {
          fontWeight: '700'
        }
      }, {
        uniqueId: 'passives',
        header: 'Passives',
        width: '120px',
        maxWidth: '120px',
        isHeaderTextHide: true,
        image: 'assets/images/passive.svg',
        style: {
          header: 'flex-end',
          row: 'flex-end'
        },
        textStyle: {
          fontWeight: '700'
        }
      }, {
        uniqueId: 'detractors',
        header: 'Detractors',
        width: '120px',
        maxWidth: '120px',
        isHeaderTextHide: true,
        image: 'assets/images/detractors.svg',
        style: {
          header: 'flex-end',
          row: 'flex-end'
        },
        textStyle: {
          fontWeight: '700'
        }
      }]
      distributionPercentageColumns = [{
        uniqueId: 'promoters_percentage',
        header: 'Promoters %',
        width: '100px',
        maxWidth: '100px',
        isHeaderTextHide: true,
        image: 'assets/images/promoters.svg',
        style: {
          header: 'flex-end',
          row: 'flex-end'
        },
        textStyle: {
          fontWeight: '700'
        }
      }, {
        uniqueId: 'passives_percentage',
        header: 'Passives %',
        width: '100px',
        maxWidth: '100px',
        isHeaderTextHide: true,
        image: 'assets/images/passive.svg',
        style: {
          header: 'flex-end',
          row: 'flex-end'
        },
        textStyle: {
          fontWeight: '700'
        }
      }, {
        uniqueId: 'detractors_percentage',
        header: 'Detractors %',
        width: '100px',
        maxWidth: '100px',
        isHeaderTextHide: true,
        image: 'assets/images/detractors.svg',
        style: {
          header: 'flex-end',
          row: 'flex-end'
        },
        textStyle: {
          fontWeight: '700'
        }
      }]
    } else {
      ['top', 'mid', 'bottom'].forEach((label) => {
        distributionPercentageColumns.push({
          uniqueId: label + '_percentage',
          header: headerLabels[label] + ' %',
          width: '100px',
          maxWidth: '100px',
          style: {
            header: 'flex-end',
            row: 'flex-end'
          },
          textStyle: {
            fontWeight: '700'
          }
        })
        distributionColumns.push({
          uniqueId: label,
          header: headerLabels[label],
          width: '100px',
          maxWidth: '100px',
          style: {
            header: 'flex-end',
            row: 'flex-end'
          },
          textStyle: {
            fontWeight: '700'
          }
        })
      })

    }

    let tableColumns = [...defaultColumn, ...distributionPercentageColumns]
    if (isExportColumns == true) {
      tableColumns = [...defaultColumn, ...distributionColumns, ...distributionPercentageColumns]
    }
    return Helpers.deepClone(tableColumns)
  }


  private creatingLabels(): any {
    const isAccountUser: any = _.get(Helpers, 'isAccount', null);
    if (isAccountUser) {
      let npsDisplayName: string = _.get(Helpers, 'accountDetails.label_configs.NPS.value', 'NPS');
      if (!npsDisplayName) {
        npsDisplayName = 'NPS';
      }
      const obj = { top: '', mid: '', bottom: '', rating: 'Rating', display: 'Rating' };
      const mapRaterTypeToLabels = {
        '3': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', topImg: 'promoters', midImg: 'passive', bottomImg: 'detractors', rating: 'NPS', display: npsDisplayName },
        '6': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
        '4': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
        '1': { top: 'Positives', mid: '', bottom: 'Negatives' },
      };
      const raterTypeKey = this.raterType !== undefined ? this.raterType.toString() : null;
      const labels = raterTypeKey && mapRaterTypeToLabels[raterTypeKey];
      return labels ? { ...obj, ...labels } : obj;
    } else if (isAccountUser === false) {
      const scalerRaterType = Helpers.brandDetails.detailed_feedback_items.filter(item => item.is_primary_rating == true)[0]?.scale_rater_type;
      let npsDisplayName: string = _.get(Helpers, 'brandDetails.label_configs.NPS.value', 'NPS');
      if (!npsDisplayName) {
        npsDisplayName = 'NPS';
      }
      const obj = { top: '', mid: '', bottom: '', rating: 'Rating', display: 'Rating' };
      const mapRaterTypeToLabels = {
        '0-10': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
        '1-5': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
        '1-10': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
        '7': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
        '5': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
        '9': { top: 'TB', mid: 'MB', bottom: 'BB' },
        '-5 to 5': { top: 'Positives', bottom: 'Negatives' },
        '-5 to +5': { top: 'Positives', bottom: 'Negatives' },
        '8': { overalltop: 'Positives', overallbottom: 'Negatives', top: 'T3B', mid: 'MB', bottom: 'B3B' }
      };
      const raterTypeKey = scalerRaterType !== undefined ? scalerRaterType.toString() : null;
      const labels = raterTypeKey && mapRaterTypeToLabels[raterTypeKey];
      return labels ? { ...obj, ...labels } : obj;
    }
  }

  onFullScreen(event: any, cardType?: any) {
    if (this.isOverallDataAvailable) {
      this.drillDownCardFullScreen = event
    }
    if(this.drillDownCardFullScreen){
      document.addEventListener('keydown', this.onEscapeKeyPress.bind(this));
      this.setDropdownConfigWidth('218px')
    }else{
      document.removeEventListener('keydown', this.onEscapeKeyPress.bind(this));
      this.setDropdownConfigWidth('160px')
    }
    
  }

  onWidgetClick(event: any) {
    if(this.drillDownCardFullScreen && event.target && this.drilldownCardContainer.nativeElement !== event.target && !this.drilldownCardContainer.nativeElement.contains(event.target)){
      this.scoreWidgetComponent.onFullscreen();
    }
  }

  onEscapeKeyPress(event: any, eventType?: string) {
    if (event.key === 'Escape' || event.keyCode === 27 || eventType === 'clickOutside') {
      this.closeFullScreen(event);
    }
  }

  closeFullScreen(event: any) {
    event.preventDefault();
    // event.stopPropagation();
    if (this.drillDownCardFullScreen) {
      this.scoreWidgetComponent.onFullscreen();
    }
  }

  onDownload(dataType: any) {
    let isDataAvailable: boolean = false;
    let downloadConfig: any = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      data: [{
        columns: [...this.overallTable.fixedHeader, ...this.overallTable.header],
        rows: this.overallTable.row
      }, {
        columns: [...this.drilldownTable.fixedHeader, ...this.drilldownTable.header],
        rows: this.drilldownTable.row
      }]
    }
    if (dataType == 'drilldown' && this.isOverallDataAvailable) {
      downloadConfig.fileDetails = {
        title: 'Score Overview - ' + this.selectedRowFilter.name + " VS " + this.selectedColumnFilter.name,
        fileName: 'Score Overview - ' + this.selectedRowFilter.name + " VS " + this.selectedColumnFilter.name,
        accountOrBrandName: this.accountDetails.display_name || this.accountDetails.name,
        isAccount: true
      }
      downloadConfig.data = [{
        columns: [...this.overallTable.fixedHeader, ...this.overallTable.header],
        rows: this.overallTable.row
      }, {
        columns: [...this.drilldownTable.fixedHeader, ...this.drilldownTable.header],
        rows: this.drilldownTable.row
      }]
      isDataAvailable = true
    } else if (dataType == 'top_performers' && this.isPerformerDataAvailable) {
      downloadConfig.fileDetails = {
        title: 'Top ' + this.cohortDetail.name,
        fileName: 'Top ' + this.cohortDetail.name,
        accountOrBrandName: this.accountDetails.display_name || this.accountDetails.name,
        isAccount: true
      }
      downloadConfig.data = [{
        columns: this.getPerformersColumn(true),
        rows: this.topResponses
      }]
      isDataAvailable = true
    } else if (dataType == 'bottom_performers' && this.isPerformerDataAvailable) {
      downloadConfig.fileDetails = {
        title: 'Bottom ' + this.cohortDetail.name,
        fileName: 'Bottom ' + this.cohortDetail.name,
        accountOrBrandName: this.accountDetails.display_name || this.accountDetails.name,
        isAccount: true
      }
      downloadConfig.data = [{
        columns: this.getPerformersColumn(true),
        rows: this.bottomResponses
      }]
      isDataAvailable = true
    }
    if (isDataAvailable) {
      this._analytics.prepareAndDownloadData(downloadConfig);
    }

  }

  private applyComparisonApiDateRange(payload: any): void {
    if (!payload) {
     return;
    }
    applyComparisonApiDateRange(
     payload,
     _.get(Helpers, 'datePicker', null)
    );
  }
}
